var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"eqc-dialog-xdcost",attrs:{"id":"mainiframe","src":_vm.compileUrl,"frameborder":"0","width":_vm.width,"height":_vm.height,"scrolling":"no"}})}
var staticRenderFns = []

export { render, staticRenderFns }